import { render } from "./BareBonesLayout.vue?vue&type=template&id=803dd046"
import script from "./BareBonesLayout.vue?vue&type=script&lang=js"
export * from "./BareBonesLayout.vue?vue&type=script&lang=js"

import "./BareBonesLayout.vue?vue&type=style&index=0&id=803dd046&lang=scss"
script.render = render

export default script